import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export const Animation = (() => {
	'use strict';

	function init() {
		if($('body').hasClass('home')){
			headerAnimation();
		}
	}

	function headerAnimation(){
		gsap.to('header.site-header', {
			backgroundColor: '#ffff',
			boxShadow: "0 0 2em rgba(0, 0, 0, 0.2)",
			ease: 'none',
			scrollTrigger: {
				trigger: '#pxMainContent',
				// endTrigger: '.pxblock--homepage section.a1c',
				start: 'top top',
				end: '+=200px',
				scrub: true
			}
		});

		gsap.to('header.site-header .site-header__mobile-trigger', {
			color: '#A5906B',
			ease: 'none',
			scrollTrigger: {
				trigger: '#pxMainContent',
				// endTrigger: '.pxblock--homepage section.a1c',
				start: 'top top',
				end: '+=200px',
				scrub: true
			}
		});

		gsap.to('header.site-header .logo', {
			startAt: {
				height: '7em',
			},
			height: '4em',
			ease: 'none',
			scrollTrigger: {
				trigger: '#pxMainContent',
				// endTrigger: '.pxblock--homepage section.a1c',
				start: 'top top',
				end: '+=200px',
				scrub: true,
				invalidateOnRefresh: true
			}
		});

		gsap.to('header.site-header .site-header__menus > svg', {
			startAt: {
				height: '7em',
			},
			height: '4em',
			ease: 'none',
			scrollTrigger: {
				trigger: '#pxMainContent',
				// endTrigger: '.pxblock--homepage section.a1c',
				start: 'top top',
				end: '+=200px',
				scrub: true,
				invalidateOnRefresh: true
			}
		});

		gsap.to('header.site-header .caff-logo-gold', {
			opacity: 1,
			ease: 'none',
			scrollTrigger: {
				trigger: '#pxMainContent',
				// endTrigger: '.pxblock--homepage section.a1c',
				start: 'top top',
				end: '+=200px',
				scrub: true
			}
		});
	}

	return {
		init: init
	};
})();
